var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasCustom)?_c('div',{style:({ height: _vm.btnHeight })},[(_vm.permissionStatus.company.custom_id === 1)?_c('button',{staticClass:"tmp-button",class:{ active: _vm.checkString },on:{"click":_vm.setSearchTerm}},[_c('p',[_vm._v("TMP")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }